import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface UpdateBannerProps {
  needsRefresh: boolean;
  updateSW: () => void;
}

export function UpdateBanner({ needsRefresh, updateSW }: UpdateBannerProps) {
  const { t } = useTranslation('pwa');
  const [dismissed, setDismissed] = useState(() => {
    return sessionStorage.getItem('pwa-update-dismissed') === 'true';
  });

  if (!needsRefresh || dismissed) {
    return null;
  }

  const handleDismiss = () => {
    sessionStorage.setItem('pwa-update-dismissed', 'true');
    setDismissed(true);
  };

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-3 rounded-lg bg-gray-900 px-4 py-3 text-white shadow-lg"
    >
      <span className="text-sm font-medium">{t('updateAvailable')}</span>
      <button
        onClick={updateSW}
        aria-label={t('updateButton')}
        className="rounded bg-orange-500 px-3 py-1 text-sm font-semibold text-white hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-1 focus:ring-offset-gray-900"
      >
        {t('updateButton')}
      </button>
      <button
        onClick={handleDismiss}
        aria-label={t('dismissButton')}
        className="rounded px-2 py-1 text-sm text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-gray-400"
      >
        {t('dismissButton')}
      </button>
    </div>
  );
}
